import React from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";
import SubHeader from "../../../../../components/SubHeader";
import Grid from "@mui/material/Grid";
import SupplierDetailList from "./DetailList";
import styles from "./style";
import { ReactComponent as Edit } from "../../../../../assets/AccountingModule/uil_edit.svg";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useAlert } from "../../../../../context/AlertContext";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../../../utils/DateFormat";

const SupplierDetailPage = ({ data, count, page, setPage, handleSearch, purchaseList, handleDelete, item, supplierList, oneSupplierDetails }) => {

  const theme = useTheme();
  const { showAlert } = useAlert();
  const navigate = useNavigate();

  const handleAlert = () => {
    showAlert("Development In Progress", "success");
  };

  const handleText = (text) => {
    handleSearch(text);
  };

  const handleSort = (sort) => {
    handleSearch("", sort);
  };

  return (
    <>
      <Box px="15px" pt="20px" display={{ xs: "block", md: "flex" }} justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={styles.heading}>Supplier Details</Typography>
        <Box display="flex" justifyContent={{ xs: "start", md: "center" }} alignItems={{ xs: "start", md: "center" }} mt={{ xs: 2, md: 0 }}>
          <Button variant="contained" color="success" sx={styles.checkoutBtn} onClick={handleAlert}>
            Statement
          </Button>
          <Box sx={styles.editIcon}><Edit onClick={handleAlert} /></Box>
          <Box sx={styles.dltIcon}><DeleteOutlineIcon onClick={handleAlert} sx={{ height: "22px" }} /></Box>
        </Box>
      </Box>

      <Grid container sx={{ justifyContent: "space-between" }}>
        <Grid item xs={12} md={5.9} lg={3.7} sx={styles.gridbox}>
          <Box sx={styles.inputSection}>
            <Typography sx={styles.infoHeading}>Supplier Information</Typography>
            <Typography sx={styles.infoText}>{`Name: ${oneSupplierDetails?.name || "N/A"}`}</Typography>
            <Typography sx={styles.infoText}>{`Email: ${oneSupplierDetails?.email || "N/A"}`}</Typography>
            <Typography sx={styles.infoText}>
              {`Phone: ${oneSupplierDetails?.phone ? oneSupplierDetails.phone : "N/A"}`}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={5.9} lg={3.9} sx={styles.gridboxes}>
          <Box sx={styles.inputSection}>
            <Typography sx={styles.infoHeading}>Billing Information</Typography>
            <Typography sx={styles.infoText}>
              {`Address: ${oneSupplierDetails?.billingAddress?.street1 || "N/A"} ${oneSupplierDetails?.billingAddress?.street2 || ""}`}
            </Typography>
            <Typography sx={styles.infoText}>{`City: ${oneSupplierDetails?.billingAddress?.city || "N/A"}`}</Typography>
            <Typography sx={styles.infoText}>{`Country: ${oneSupplierDetails?.billingAddress?.country || "N/A"}`}</Typography>
            <Typography sx={styles.infoText}>{`ZipCode: ${oneSupplierDetails?.billingAddress?.pinCode || "N/A"}`}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={5.9} lg={3.6} sx={styles.gridboxs}>
          <Box sx={styles.inputSection}>
            <Typography sx={styles.infoHeading}>Business Information</Typography>
            <Typography sx={styles.infoText}>{`Credit Limit: ${oneSupplierDetails?.creditLimits || "N/A"}`}</Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} lg={11.8} sx={styles.companybox}>
          <Box sx={styles.inputSection}>
            <Typography sx={styles.infoHeading}>Company Information</Typography>
            <Grid container>
              <Grid item xs={5.8} lg={3.5} sx={styles.companyGrid}>
                <Box sx={styles.companyBox}>
                  <Typography sx={styles.infoText}>Supplier ID</Typography>
                  <Typography sx={styles.infoValue}>{oneSupplierDetails?._id || "N/A"}</Typography>
                  <Typography sx={styles.infoText}>Total Sum of Bills</Typography>
                  <Typography sx={styles.infoValues}>0.00$</Typography>
                </Box>
              </Grid>
              <Grid item xs={5.8} lg={3.9} sx={styles.companyGrid}>
                <Box sx={styles.companyBox}>
                  <Typography sx={styles.infoText}>Date of Creation</Typography>
                  <Typography sx={styles.infoValue}>
                    {oneSupplierDetails?.createdAt && !isNaN(new Date(oneSupplierDetails.createdAt))
                      ? formatDate(new Date(oneSupplierDetails.createdAt), "MMM d, yyyy")
                      : "N/A"}
                  </Typography>
                  <Typography sx={styles.infoText}>Quantity of Bills</Typography>
                  <Typography sx={styles.infoValues}>{count || 0}</Typography>
                </Box>
              </Grid>
              <Grid item xs={5.8} lg={3.6} sx={styles.companyGrid}>
                <Box sx={styles.companyBox}>
                  <Typography sx={styles.infoText}>Balance</Typography>
                  <Typography sx={styles.infoValue}>0.00$</Typography>
                  <Typography sx={styles.infoText}>Average Sales</Typography>
                  <Typography sx={styles.infoValues}>0.00$</Typography>
                </Box>
              </Grid>
              <Grid item xs={5.8} lg={1} sx={styles.companyGrids}>
                <Box sx={styles.companyBox}>
                  <Typography sx={styles.infoText}>Overdue</Typography>
                  <Typography sx={styles.infoValues}>0$</Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>

      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }}>
        <SubHeader
          title="Purchase list"
          search={true}
          sortBy={true}
          isShowFilter={true}
          onchange={handleText}
          handleSort={handleSort}
          filter={handleAlert}
        />
        <SupplierDetailList
          data={data}
          count={count}
          page={page}
          setPage={setPage}
          handleDelete={handleDelete}
        />
      </Box>
    </>
  );
};

export default SupplierDetailPage;